<template>
  <el-menu
    :default-active="activeIndex2"
    class="el-menu-demo"
    mode="horizontal"
    background-color="#545c64"
    text-color="#fff"
    active-text-color="#ffd04b"
    @select="handleSelect"
  >
    <el-menu-item index="1">
      <router-link to="/home/teacherIntroduction"> 首页 </router-link>
    </el-menu-item>

    <el-menu-item index="2">
      <router-link to="/login"> 课程服务 </router-link>
    </el-menu-item>

    <el-menu-item index="4">
      <a href="http://www5.zzu.edu.cn/nlp/">关于我们</a>
    </el-menu-item>
  </el-menu>
</template>

<script>
export default {
    name:"TopMenu",
};
</script>

<style>
</style>